'use client'

import { getAuth } from 'firebase/auth'
import { useAuthState } from 'react-firebase-hooks/auth'
import { CalendarIcon, Navbar, PowerIcon, UsersIcon } from '@/components'
import { useIsTenantMaintenanceHidden } from '@/hooks'
import { ROUTES } from '@/lib/constants/routes'

export function NavBarWrapper({ lang }: { lang: Language }) {
  const [user, loading, error] = useAuthState(getAuth())
  const tenantId = user?.tenantId
  const { isHidden, isLoading: tenantConfigLoading } = useIsTenantMaintenanceHidden(tenantId)

  if (loading) return

  if (error) throw error

  const tenantIdForPath = tenantId ?? ''

  const menus = [
    {
      id: 'desired-shift',
      title: 'シフト管理',
      icon: <CalendarIcon fontSize={16} />,
      path: `${ROUTES.SHIFT_APP}`,
    },
    {
      id: 'account-management',
      title: 'アカウント管理',
      icon: <UsersIcon fontSize={16} />,
      subMenus: [
        {
          id: 'tenant-info',
          title: 'テナント情報',
          path: `${ROUTES.TENANTS}/${tenantIdForPath}`,
        },
        {
          id: 'accounts',
          title: 'アカウント一覧',
          path: ROUTES.ACCOUNTS,
        },
        {
          id: 'administrators',
          title: '法人システム管理者一覧',
          path: ROUTES.ADMINISTRATORS,
        },
      ],
    },
  ]

  if (!tenantConfigLoading && !isHidden) {
    menus.push({
      id: 'tenant-maintenance',
      title: 'テナントメンテナンス',
      icon: <PowerIcon fontSize={16} />,
      path: `${ROUTES.TENANTS}/${tenantIdForPath}/${ROUTES.TENANT_MAINTENANCE}`,
    })
  }

  return <Navbar lang={lang} menus={menus} />
}
